import React from 'react';
import { Box, Typography, Card, CardContent, CardMedia, Button, IconButton, Pagination, Divider } from '@mui/material';
import { Visibility, GetApp, ContentCopy, WhatsApp, Facebook } from '@mui/icons-material';
import { primaryColor } from '../theme';

const renderContent = (category, items, handleViewMore, handleShare, handleCopy, currentPage, handlePageChange, itemsPerPage) => {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = items.slice(startIndex, endIndex);

  return (
    <Box mb={4}>
      <Typography variant="h4" gutterBottom style={{ color: primaryColor, fontWeight: 'bold' }}>
        {category}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box display="flex" flexWrap="wrap" gap={2}>
        {paginatedItems.map((item) => (
          <Box key={item.id} width={item.platform === 'Audio' ? '95%' : { xs: '100%', sm: '48%', md: '31%' }} mb={2}>
            {item.platform === 'Presentations' || item.platform === 'Written' ? (
              <Card sx={{ height: '100%' }}>
                {item.image && (
                  <CardMedia
                    component="img"
                    height="300"
                    image={item.image}
                    alt={item.topic}
                  />
                )}
                <CardContent>
                  <Box mb={2}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>{item.topic}</Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      {item.summary.length > 150 ? `${item.summary.substring(0, 250)}...` : item.summary}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="caption" color="textSecondary">
                        {item.period}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" display="flex" alignItems="center" gap={0.5}>
                        <Visibility fontSize="small" /> {item.views}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" display="flex" alignItems="center" gap={0.5}>
                        <GetApp fontSize="small" /> {item.downloads}
                      </Typography>
                    </Box>
                    <Button size="small" color="primary" onClick={() => handleViewMore(item.id)}>
                      View More
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            ) : item.platform === 'Video' ? (
              <Card sx={{ height: '100%' }}>
                <CardMedia
                  component="video"
                  controls
                  height="300"
                  src={item.video}
                  alt={item.topic}
                />
                <CardContent>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>{item.topic}</Typography>
                    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="caption" color="textSecondary">
                        {item.period}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" display="flex" alignItems="center" gap={0.5}>
                        <Visibility fontSize="small" /> {item.views}
                      </Typography>
                    </Box>
                  </Box>
                  </Box>
                </CardContent>
              </Card>
            ) : item.platform === 'Audio' ? (
              <Box display="flex" alignItems="center" mb={0} p={1} borderBottom={1} borderColor="grey.300">
                <Box flexGrow={1}>
                  <Typography variant="h6" fontSize="medium" >{item.topic}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {item.period}
                  </Typography>
                </Box>
                <Box ml={2}>
                  <audio controls>
                    <source src={item.audio} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </Box>
                <Typography ml={2} variant="caption" color="textSecondary" display="flex" alignItems="center" gap={0.5}>
                  <Visibility fontSize="small" /> {item.views}
                </Typography>
              </Box>
            ) : item.platform === 'SMS' ? (
              <Box mb={2} p={2} border={1} borderColor="grey.300" borderRadius={2} sx={{ height: '80%' }}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>{item.topic}</Typography>
                  <IconButton onClick={() => handleCopy(item.content, item.topic, item.id)}>
                    <ContentCopy />
                  </IconButton>
                </Box>
                <Typography variant="body1" dangerouslySetInnerHTML={{ __html: item.content }} />
              </Box>
            ) : item.platform === 'Whatsapp' || item.platform === 'Facebook' ? (
              <Card sx={{ height: '100%' }}>
                {/* {item.image && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={item.image}
                    alt={item.topic}
                    style={{ objectFit: 'cover' }}
                  />
                )} */}
                <CardContent>
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>{item.topic}</Typography>
                  <Typography variant="body1" dangerouslySetInnerHTML={{ __html: item.content }} />
                  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                    Share <IconButton size="small" color="primary" onClick={() => handleShare(item.platform, item.content, item.topic, item.id)}>
                      {item.platform === 'Whatsapp' ? <WhatsApp /> : <Facebook />}
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            ) : null}
          </Box>
        ))}
      </Box>
      <Box mt={4} display="flex" justifyContent="center">
        <Pagination
          count={Math.ceil(items.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default renderContent;